export const NETWORK_ROUTE_SEGMENTS = {
  root: "network",
  connections: "connections",
  connectionId: ":connectionId",
  productRequests: "product-requests",
  supplier: "supplier",
} as const;

export const NETWORK_PATH = `/${NETWORK_ROUTE_SEGMENTS.root}`;

export const NETWORK_CONNECTIONS_PATH = `${NETWORK_PATH}/${NETWORK_ROUTE_SEGMENTS.connections}`;

export const NETWORK_CONNECTION_DETAIL_PATH = `${NETWORK_CONNECTIONS_PATH}/${NETWORK_ROUTE_SEGMENTS.connectionId}`;

export const NETWORK_PRODUCT_REQUESTS_PATH = `${NETWORK_PATH}/${NETWORK_ROUTE_SEGMENTS.productRequests}`;

export const NETWORK_SUPPLIER_PATH = `${NETWORK_PATH}/${NETWORK_ROUTE_SEGMENTS.supplier}`;

export const NETWORK_SUPPLIER_CONNECTIONS_PATH = `${NETWORK_SUPPLIER_PATH}/${NETWORK_ROUTE_SEGMENTS.connections}`;

export const NETWORK_SUPPLIER_CONNECTION_DETAIL_PATH = `${NETWORK_SUPPLIER_CONNECTIONS_PATH}/${NETWORK_ROUTE_SEGMENTS.connectionId}`;

export const NETWORK_SUPPLIER_PRODUCT_REQUESTS_PATH = `${NETWORK_SUPPLIER_PATH}/${NETWORK_ROUTE_SEGMENTS.productRequests}`;

export const NETWORK_SUPPLIER_REGISTER_PATH = `${NETWORK_SUPPLIER_PATH}/register`;

export const NETWORK_SUPPLIER_FORWARD_INVITE_PATH = `${NETWORK_SUPPLIER_PATH}/forward-invite`;

export const NETWORK_SUPPLIER_SELECT_ACCOUNT_PATH = `${NETWORK_SUPPLIER_PATH}/select-account`;

export const buildNetworkConnectionPath = (connectionId: string): string =>
  NETWORK_CONNECTION_DETAIL_PATH.replace(":connectionId", connectionId);

export const buildNetworkSupplierConnectionPath = (connectionId: string): string =>
  NETWORK_SUPPLIER_CONNECTION_DETAIL_PATH.replace(":connectionId", connectionId);

const buildSupplierInvitationPath = (path: string, connectionRequestId: string, token: string): string =>
  `${path}?cr=${encodeURIComponent(connectionRequestId)}&token=${encodeURIComponent(token)}`;

export const buildNetworkSupplierForwardInvitePath = (connectionRequestId: string, token: string): string =>
  buildSupplierInvitationPath(NETWORK_SUPPLIER_FORWARD_INVITE_PATH, connectionRequestId, token);

export const buildNetworkSupplierSelectAccountPath = (connectionRequestId: string, token: string): string =>
  buildSupplierInvitationPath(NETWORK_SUPPLIER_SELECT_ACCOUNT_PATH, connectionRequestId, token);
